import type { CatalogResponse } from '@nadoutong/contracts';
import { platformApiRequest } from './client.ts';

export type ConsoleCatalogBrand = 'nadoutong' | 'nxtpath';

export async function getCatalogForBrand(
  fetchImpl: typeof fetch,
  brand: ConsoleCatalogBrand,
  signal?: AbortSignal,
): Promise<CatalogResponse> {
  const params = new URLSearchParams({ brand });
  return platformApiRequest<CatalogResponse>(
    `/v1/catalog/me?${params.toString()}`,
    { signal },
    fetchImpl,
  );
}

/**
 * Nadoutong-pinned catalog fetcher. console-web always requests the
 * `nadoutong` brand catalog; the brand-parameterised variant above is
 * kept export-compatible with the previous re-export surface.
 */
export async function getCatalog(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<CatalogResponse> {
  return getCatalogForBrand(fetchImpl, 'nadoutong', signal);
}
